import {
  IonCheckbox,
  IonContent,
  IonInput,
  IonItem,
  IonPage,
  useIonToast,
  useIonViewDidEnter
} from '@ionic/react'

import { useEffect, useState } from 'react'
import logo from '../../../src/utils/img/logo-login.png'
import { clearLogin, getLogin, login as loginService, saveLogin } from '../../service/session'
import { DivCheck, DivEl, LoginButtomEl, MainDivEl } from './styled'

interface Param {
  loginSuccess: Function
}

const Login: React.FC<Param> = ({loginSuccess}) => {

  const [present] = useIonToast()
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [saveUser, setSaveUser] = useState(true);

  useEffect(() => {
    console.log('Tela de login carregada!');
    const run = async () => {
      const login = await getLogin();
      console.log('Tela de login carregada!', login);
      if (login.email) {
        setEmail(login.email);
      }
      if (login.password) {
        setPassword(login.password);
      }
    } 
    run();
  }, []);
  
  const login = async () => {
    try {
      await loginService(email, password);
      if (saveUser) {
        saveLogin(email, password);
      } else {
        clearLogin();
      }
      loginSuccess();
    } catch (error: any) {
      let mensagem = 'Usuário inválido !';

      if (error!.response!.status !== 401 && error.response.data && error.response.data.message) {
        mensagem = mensagem + error.response.data.message;
      }

      present({
        message: mensagem,
        duration: 1_500,
        position: 'top'
      })
    }
  };

  return (
    <IonPage>
      <IonContent>
        <DivEl>
          <MainDivEl>
            <img style={{height: '12em', marginBottom: '2em'}} src={logo} alt=''></img>

            <form>
              <span>Email</span>

              <div style={{ display: 'flex', width: '100%', marginBottom: '2em' }}>
                <IonItem>
                  <IonInput
                    id='email'
                    name='email'
                    value={email}
                    placeholder='Digite seu e-mail'
                    onIonChange={(e: any) => setEmail(e.target.value)}>
                  </IonInput>
                </IonItem>
              </div>

              <span>Senha</span>

              <div style={{ display: 'flex', width: '100%' }}>
                <IonItem>
                  <IonInput
                    id='password'
                    name='password'
                    value={password}
                    type='password'
                    placeholder='Digite sua senha'
                    onIonChange={(e: any) => setPassword(e.target.value)}>
                  </IonInput>
                </IonItem>
              </div>
            </form>
            <DivCheck> 
              <IonCheckbox 
                checked={saveUser}
                onIonChange={(e: any) => setSaveUser(e.detail.checked)}
              /> 
              <div>Salvar senha</div>
            </DivCheck>
         

            <LoginButtomEl type="button" onClick={login}>
              Entrar
            </LoginButtomEl>

          </MainDivEl>
        </DivEl>
      </IonContent>
    </IonPage>
  );
};

export default Login;
